import React, { useContext } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons'

import { GlobalContext } from '../../context/globalContext'
import G from '../../util/globalFunction'

export default props => {
    let {
        page: {
            props: { path },
        },
    } = props
    if (path == '/') {
        path = '/home/'
    }
    const globalContext = useContext(GlobalContext)
    const { getHelpDocPath } = globalContext
    const helpDocPath = getHelpDocPath(path)
    return helpDocPath ? (
        <div
            className="px-2 cursor-pointer"
            onClick={e => {
                e.preventDefault()

                G.gotoPage(`/helpdoc${path}`)
            }}
        >
            <FontAwesomeIcon icon={faQuestionCircle} size="sm" />
        </div>
    ) : null
}
